<template>
  <tr>
    <td>
      {{item.nome}}
    </td>

    <td class="text-center">
      <app-toggle v-model="advertiserCanCreateAdvertising"></app-toggle>
    </td>

    <td class="text-center">
      <app-toggle v-model="advertiserViewLeads"></app-toggle>
    </td>

    <!-- <td class="text-center">
      <app-toggle v-model="advertiserAskForApproval"></app-toggle>
    </td> -->

    <td class="text-center">
      <app-toggle v-model="establishmentCanCreateAdvertising"></app-toggle>
    </td>

    <td class="text-center">
      <app-toggle v-model="establishmentViewResults"></app-toggle>
    </td>

    <!-- <td class="text-center">
      <app-toggle v-model="establishmentAskForApproval"></app-toggle>
    </td> -->

    <td class="text-center">
      {{item.porcentagemVeiculacao}} %
    </td>

    <td class="text-center edit">
      <!-- <i class="mdi  mdi-lock-open-outline pointer"
         :class="item.tipoLimiteAcesso ? 'icon-green' : ''"
         style="margin: auto;"
         v-tooltip="'Limitar acessos/Leads'"
         @click="editBind"></i> -->

      <div class="unbind"
           @click="unbind">
        &times;
      </div>
    </td>

    <app-confirmation-modal :value="!!pendingDisable"
                            confirm-label="Confirmar"
                            @confirm="confirmDisable(pendingDisable)"
                            @cancel="cancelDisable">
      <span slot="heading">
        Desativar '{{pendingDisable ? pendingDisable.label : ''}}'
      </span>
      <span>
        Confirma desativação?
      </span>
    </app-confirmation-modal>
    <app-confirmation-modal :value="!!pendingUnbind"
                            confirm-label="Confirmar"
                            @confirm="confirmUnbind()"
                            @cancel="pendingUnbind = null">
      <span slot="heading">
        Excluir vínculo?
      </span>
    </app-confirmation-modal>

  </tr>
</template>

<script>
    import tableItem from '@mixins/table-item'
    import EventBus from '@packages/event-bus'
    import AppConfirmationModal from '@components/ConfirmationModal'

    export default {
        components: {
            AppConfirmationModal
        },

        data() {
            return {
                unbinding: false,
                pendingDisable: null,
                pendingUnbind: null
            }
        },

        props: {
            dataAdvertiserId: {
                type: Number,
                required: true
            },
        },


        computed: {
            advertiserCanCreateAdvertising: {
                get() {
                    return this.item.permitirAnuncianteCriarCampanha
                },
                set(value) {
                    this.item.permitirAnuncianteCriarCampanha = value;
                    if (value) {
                        this.confirmDisable({field : 'permitirAnuncianteCriarCampanha', value: value})
                    } else {
                        this.changeField('permitirAnuncianteCriarCampanha', value, 'Criar Campanha')
                    }
                },
            },
            advertiserViewLeads: {
                get() {
                    return this.item.permitirAnuncianteVisualizarLead
                },
                set(value) {
                    this.edit({
                        field: 'permitirAnuncianteVisualizarLead',
                        value
                    })
                },
            },
            // advertiserAskForApproval: {
            //     get() {
            //         return this.item.solicitarAprovacaoAnunciante
            //     },
            //     set(value) {
            //         this.item.solicitarAprovacaoAnunciante = value;
            //         if (value) {
            //             this.confirmDisable({field : 'solicitarAprovacaoAnunciante', value: value})
            //         } else {
            //             this.changeField('solicitarAprovacaoAnunciante', value, 'Aprovar Campanha')
            //         }
            //     },
            // },
            establishmentCanCreateAdvertising: {
                get() {
                    return this.item.permitirEstabelecimentoCriarCampanha
                },
                set(value) {
                    this.item.permitirEstabelecimentoCriarCampanha = value;
                    if (value) {
                        this.confirmDisable({field : 'permitirEstabelecimentoCriarCampanha', value: value})
                    } else {
                        this.changeField('permitirEstabelecimentoCriarCampanha', value, 'Criar Campanha')
                    }
                },
            },
            establishmentViewResults: {
                get() {
                    return this.item.permitirEstabelecimentoVisualizarResultados
                },
                set(value) {
                    this.edit({
                        field: 'permitirEstabelecimentoVisualizarResultados',
                        value
                    })
                },
            },
            // establishmentAskForApproval: {
            //     get() {
            //         return this.item.solicitarAprovacaoEstabelecimento
            //     },
            //     set(value) {
            //         this.item.solicitarAprovacaoEstabelecimento = value;
            //         if (value) {
            //             this.confirmDisable({field : 'solicitarAprovacaoEstabelecimento', value: value})
            //         } else {
            //             this.changeField('solicitarAprovacaoEstabelecimento', value, 'Aprovar Campanha')
            //         }
            //     },
            // },
        },

        methods: {
            editBind(){
                EventBus.$emit('EDIT_BIND_OPTIONS', this.dataAdvertiserId, JSON.parse(JSON.stringify(this.item)))
            },
            changeField(field, value, label) {
                this.pendingDisable = {field : field, value : value, label : label}
            },

            async confirmDisable(pendingDisable) {
                try {
                    this.edit({
                        field: pendingDisable.field,
                        value: pendingDisable.value
                    })
                } catch (e) {
                    this.item[pendingDisable.field] = !this.item[pendingDisable.field]
                }
                this.pendingDisable = null
            },

            cancelDisable(){
                this.item[this.pendingDisable.field] = !this.item[this.pendingDisable.field]
                this.pendingDisable = null
            },

            async confirmUnbind() {
                this.unbinding = true
                await this.$api.advertisers.unbindEstablishment({
                    advertiserId: this.dataAdvertiserId,
                    establishmentId: this.pendingUnbind
                })

                EventBus.$emit('ESTABLISHMENT_UNBOUND')
                this.pendingUnbind = null
            },


            async unbind() {
                this.pendingUnbind = this.item.id

            },

            async edit({field, value}) {
                this.item[field] = value
                this.$api.advertisers.editBinding({
                    advertiserId: this.dataAdvertiserId,
                    establishmentId: this.item.id,
                    field,
                    value
                })
            },
        },

        mixins: [tableItem]
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

td {
  padding: 0 22px !important;

  &:last-child {
  }

  .unbind {
    border: 1px solid $grey-2;
    border-radius: 50%;
    height: 24px;
    width: 24px;
    cursor: pointer;
    margin: auto;
    margin-left: 10px;
  }
}
.icon-green {
  color: $primary;
}

.edit {
  display: flex;
}
</style>
